import { configureStore } from '@reduxjs/toolkit';
import productReducer from './productSlice';
import cartReducer from './cartSlice';
import orderReducer from './orderSlice';

//cake part

import cakeOrderReducer from './cakeOrderSlice';
import cakeCartReducer from './cakeCartSlice';
import cakeProductReducer from './cakeProductSlice';

export const store = configureStore({
  reducer: {
    products: productReducer,
    cart: cartReducer,
    order: orderReducer,
  
    //cake part
    cakeCart: cakeCartReducer,
    cakeProduct: cakeProductReducer,
    cakeOrder: cakeOrderReducer,
  },
});